import { render, staticRenderFns } from "./WM3.vue?vue&type=template&id=2c654c18&scoped=true&"
import script from "./WM3.vue?vue&type=script&lang=js&"
export * from "./WM3.vue?vue&type=script&lang=js&"
import style0 from "./WM3.vue?vue&type=style&index=0&id=2c654c18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c654c18",
  null
  
)

export default component.exports